<template>
  <div id="q-app">
    <router-view />
  </div>
</template>

<script>
import 'lodash'
import { REFRESH_DATA } from '@/store/action-types'
import { onMessage } from '@/utils/notifications'
import {
  APP_NOTIF_PLANNING_EDITED,
  APP_NOTIF_PLANNING_UPDATED,
  APP_NOTIF_SERVICE_EVENT,
  APP_NOTIF_SERVICE_LATE,
  APP_NOTIF_SERVICE_SOON,
  APP_NOTIF_SITE_INSTRUCTIONS_UPDATED,
  APP_NOTIF_SUPERVISION_AGENT_LOCATION,
  EVENT_UPDATE_AGENT_LOCATION,
  MODAL_EVENT_UPDATE_SITE_INSTRUCTIONS
} from '@/consts/app'
import { checkAppVersion, toast } from '@/utils/ui'
import { modalMainCourante, modalSiteInstructions } from '@/utils/ui/modal'
import { devLog } from '@/utils'
import { createNamespacedHelpers } from 'vuex'
import { ROUTE_NAME_TERRAIN_PLANNING } from '@/router/terrain'
import '@/utils/pti'

const storeUser = createNamespacedHelpers('user')
const storeAgency = createNamespacedHelpers('user/agency')
export default {
  name: 'App',
  computed: {
    ...storeAgency.mapGetters({
      getSite: 'getSite'
    }),
    ...storeUser.mapGetters({
      agencySlug: 'agencySlug'
    })
  },
  created () {
    checkAppVersion()
    setInterval(checkAppVersion, 3600000) // Check la version de l'appli toutes les heures
    process.env.DEV
      ? devLog('En dev, le rafraichissement de la session est manuelle (Rafraichir dans le DEVTools)')
      : this.$store.dispatch(REFRESH_DATA)
    if (this.$store.getters['user/isLoggedIn']) {
      this.$ui.fbCheckDeviceRegistration()
    }
    const _onMessage = ({
      data: {
        lwfType,
        agencySlug,
        serviceEventRef,
        slugSite,
        message: dataMessage,
        agent,
        location
      },
      tap = null,
      ...message
    }) => {
      if (lwfType) {
        devLog('Message de type', lwfType)
        switch (lwfType) {
          case APP_NOTIF_PLANNING_UPDATED: {
            devLog('mise à jour du planning')
            break
          }
          case APP_NOTIF_SERVICE_LATE:
          case APP_NOTIF_SERVICE_SOON:
          case APP_NOTIF_PLANNING_EDITED: {
            this.$router.push({ name: ROUTE_NAME_TERRAIN_PLANNING })
            break
          }
          case APP_NOTIF_SERVICE_EVENT: {
            if (agencySlug !== this.agencySlug) {
              break
            }
            if (tap) {
              modalMainCourante({ reference: serviceEventRef })
            }
            this.$ui.getServiceEvent({ reference: serviceEventRef })
            this.$ui.unreadEvents++
            break
          }
          case APP_NOTIF_SITE_INSTRUCTIONS_UPDATED: {
            const site = this.getSite(slugSite)
            if (site) {
              if (tap) {
                modalSiteInstructions(site)
              }
              this.$ui.$emit(
                MODAL_EVENT_UPDATE_SITE_INSTRUCTIONS,
                {
                  slugSite,
                  messages: [JSON.parse(dataMessage)]
                }
              )
            }
            break
          }
          case APP_NOTIF_SUPERVISION_AGENT_LOCATION: {
            this.$ui.$emit(
              EVENT_UPDATE_AGENT_LOCATION,
              [{
                id: agent,
                location: JSON.parse(location)
              }]
            )
            break
          }
          default: {
            devLog('Non pris en compte')
          }
        }
      } else if (message.messageType === 'notification' && message.title && !message.channel_id) {
        toast.info({
          message: message.title,
          caption: message.body
        })
      }
    }
    if (this.$q.platform.is.desktop && 'serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener(
        'message', ({ data }) => {
          if (data && data.type === 'firebase-messaging') {
            _onMessage(data.payload)
          }
        })
    }
    onMessage(_onMessage)
    this.preLoadGmap()
  },
  methods: {
    async preLoadGmap () {
      await this.$nextTick()
      window.lwfGoogleMapsPromise = this.$gmapApiPromiseLazy() // Chargement de googlemaps
    }
  }
}
</script>
